import React from 'react';

export interface RolloutContextData {
    inCaribouPortfolioAttachmentReportRollout?: boolean;
    inMustangsUpdateProfilePhotoRollout?: boolean;
    inQualasNewLevelSystemRollout?: boolean;
    inZebrasHourlyRateRollout?: boolean;
    inStorksBackgroundCheckRollout?: boolean;
    inCobrasOpenHourlyToMpRollout?: boolean;
}

const RolloutContext = React.createContext<RolloutContextData>({
    inCaribouPortfolioAttachmentReportRollout: false,
    inMustangsUpdateProfilePhotoRollout: false,
    inQualasNewLevelSystemRollout: false,
    inZebrasHourlyRateRollout: false,
    inStorksBackgroundCheckRollout: false,
    inCobrasOpenHourlyToMpRollout: false,
});

/**
 * Value contains Object with keys in format of
 * in[RolloutName]Rollout
 *
 * Example: {
 *   inVipersProjectDeliveriesRollout: true
 * }
 */

export const RolloutContextProvider = RolloutContext.Provider;

export const useRolloutContext = () => React.useContext(RolloutContext);
